import { Component, OnInit, Inject, inject, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { Router, ActivatedRoute } from "@angular/router";
import { StandardService } from "../services/standard.service";
import { Standard } from "../models/standard";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
// import { sideViewGloabalApprovedSolutions } from "../sideView-GloabalApprovedSolutions/sideView-GloabalApprovedSolutions";
import {
  StandardTypeEnum,
  StandardListType,
  UserRoleEnum,
  FilteringEnum,
  AllStandardsTabs,
  AddendumStatusEnum,
} from "../core/constant";
import { CryptographyService } from "../services/cryptography.service";
import { LocationService } from "../services/location.service";
import { SelectedStandard } from "../models/selected-standard";
import { SelectedStandardDetail } from "../models/selected-standard-detail";
import { MatMenuTrigger } from "@angular/material/menu";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { D } from "@angular/cdk/keycodes";
import { DatePipe, Location } from "@angular/common";
import DOMPurify from "dompurify";

import { SnackbarComponent } from "../snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
declare var $: any;

@Component({
  selector: "app-view-all-minimum-standard-detail-view",
  templateUrl: "./view-all-minimum-standard-detail-view.component.html",
  styleUrls: ["./view-all-minimum-standard-detail-view.component.scss"],
  providers: [DatePipe],
})
export class MinimumStandardDetailViewComponent implements OnInit {
   private _snackBar = inject(MatSnackBar);
       currentIndex = 0;
  cardsVisible = 4;
    allLocations: string = '';
    subLocations: string = '';
    keyContactEmail: string = '';
    createdOn: Date;
    detailsExpanded = false;
    additionalInfoExpanded = false;
    standardTypeName:string;
  loading: boolean = false;
  gapLoading: boolean = true;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<img src="/assets/images/back.svg">',
      '<img src="/assets/images/next.svg">',
    ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    nav: true,
  };
  grsId: number = 0;
  notes: SafeHtml = "";
  additionalInformation: SafeHtml = "";
  grsDetail: SelectedStandardDetail = new SelectedStandardDetail();
  error: string = "";
  userRole: number = 2;
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  getStandardTypeName(id: number): string {
  return StandardTypeEnum[id];
}
  get userRoleEnum() {
    return UserRoleEnum;
  }
  get isImpersonating(): boolean {
    return sessionStorage.getItem("impersonationView") === "true";
  }
  get countryId(): number {
    const sessionCountryId = sessionStorage.getItem("selectedCountryID");
    if (sessionCountryId) {
      try {
        return typeof sessionCountryId === 'string' ? JSON.parse(sessionCountryId) : Number(sessionCountryId);
      } catch {
        return Number(sessionCountryId);
      }
    }
    const storageCountry = this.cryptographyService.decryptData(this.storage.get("countryId"));
    return Array.isArray(storageCountry) ? storageCountry[0] : Number(storageCountry);
  }
  get countryIds(): number[] {
    const cid = this.countryId;
    if (!cid) return [];
    return [Number(cid)];
  }

 
  get keyContactEmailResolved(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.email ||
      d?.keyContact?.Email ||
      d?.standard?.keyContact?.email ||
      d?.standard?.keyContact?.Email ||
      d?.standard?.email ||
      d?.standard?.Email ||
      d?.email ||
      d?.Email ||
      this.keyContactEmail ||
      ""
    );
  }

  get linksList(): any[] {
    const d = this.grsDetail as any;
    const rawLinks = d?.links || d?.standard?.links || d?.Links || d?.standard?.Links || d?.resourceLinks1 || [];
    if (!Array.isArray(rawLinks)) return [];
    return rawLinks.map((l: any) => ({
      url: l?.url || l?.Url || "",
      title: l?.title || l?.Title || l?.url || l?.Url || ""
    })).filter(l => !!l.url?.trim() || !!l.title?.trim());
  }

  // Partly in effect: exactly one of the two dates is still in the future
  // and the other is already current/past - the standard already applies
  // to one restaurant type but not the other yet.
  private get partlyInEffectDates(): { effectiveFrom: Date; newRestaurantsEffectiveFrom: Date } | null {
    const standard = this.grsDetail?.standard as any;
    if (!standard?.effectiveFrom || !standard?.newRestaurantsEffectiveFrom) {
      return null;
    }
    const effectiveFrom = new Date(standard.effectiveFrom);
    const newRestaurantsEffectiveFrom = new Date(standard.newRestaurantsEffectiveFrom);
    if (isNaN(effectiveFrom.getTime()) || isNaN(newRestaurantsEffectiveFrom.getTime())) {
      return null;
    }
    return { effectiveFrom, newRestaurantsEffectiveFrom };
  }

  get isPartlyInEffect(): boolean {
    const dates = this.partlyInEffectDates;
    if (!dates) return false;
    const now = new Date();
    const effectiveFromIsFuture = dates.effectiveFrom > now;
    const newRestaurantsEffectiveFromIsFuture = dates.newRestaurantsEffectiveFrom > now;
    return effectiveFromIsFuture !== newRestaurantsEffectiveFromIsFuture;
  }

  get partlyInEffectMessage(): string {
    const dates = this.partlyInEffectDates;
    if (!dates) return "";
    const now = new Date();
    if (dates.effectiveFrom > now) {
      return `Already in effect for new restaurants. Applies to existing restaurants from ${this.datePipe.transform(dates.effectiveFrom, "d MMMM, yyyy")}.`;
    }
    return `Already in effect for existing restaurants. Applies to new restaurants from ${this.datePipe.transform(dates.newRestaurantsEffectiveFrom, "d MMMM, yyyy")}.`;
  }

  // Exceptions: an "active" exception is an Approved addendum whose renewal/
  // expiry date hasn't passed yet (day-level comparison, no expiry = active
  // indefinitely) - same rule as addendum.component.ts's isExceptionActive().
  private isAddendumActive(addendum: any): boolean {
    if (addendum?.addendumStatusId !== AddendumStatusEnum.Approved) return false;
    const renewalDate = addendum?.exceptionRenewalDate || addendum?.expiryDate;
    if (!renewalDate) return true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiryDay = new Date(renewalDate);
    expiryDay.setHours(0, 0, 0, 0);
    return today.getTime() <= expiryDay.getTime();
  }

  private get activeExceptions(): any[] {
    const addendum = (this.grsDetail as any)?.addendum || [];
    return addendum.filter((a: any) => this.isAddendumActive(a));
  }

  get hasActiveException(): boolean {
    return this.activeExceptions.length > 0;
  }

  private get ownCountryActiveException(): any {
    const cid = this.countryId;
    if (!cid) return null;
    return this.activeExceptions.find((a: any) => a.countryId === cid) || null;
  }

  private get exemptedCountryNames(): string {
    const names = this.activeExceptions
      .map((a: any) => a?.country?.name)
      .filter((n: string) => !!n);
    const unique = Array.from(new Set(names));
    if (unique.length === 0) return "";
    if (unique.length === 1) return unique[0];
    return `${unique.slice(0, -1).join(", ")} and ${unique[unique.length - 1]}`;
  }

  private formatExceptionPeriod(exception: any): string {
    const start = exception?.approvedOrRejectedDate
      ? this.datePipe.transform(exception.approvedOrRejectedDate, "d MMMM, yyyy")
      : null;
    const end = exception?.expiryDate
      ? this.datePipe.transform(exception.expiryDate, "d MMMM, yyyy")
      : null;
    if (start && end) return `${start} - ${end}`;
    if (end) return `Until ${end}`;
    return "";
  }

  // Multiple countries can each have their own exception dates - span the
  // earliest start to the latest end across all of them for the general
  // (non-market-specific) banner message.
  private formatExceptionPeriodRange(exceptions: any[]): string {
    const starts = exceptions
      .map((e: any) => (e?.approvedOrRejectedDate ? new Date(e.approvedOrRejectedDate) : null))
      .filter((d: Date | null) => !!d) as Date[];
    const ends = exceptions
      .map((e: any) => (e?.expiryDate ? new Date(e.expiryDate) : null))
      .filter((d: Date | null) => !!d) as Date[];
    const start = starts.length ? new Date(Math.min(...starts.map((d) => d.getTime()))) : null;
    const end = ends.length ? new Date(Math.max(...ends.map((d) => d.getTime()))) : null;
    const startStr = start ? this.datePipe.transform(start, "d MMMM, yyyy") : null;
    const endStr = end ? this.datePipe.transform(end, "d MMMM, yyyy") : null;
    if (startStr && endStr) return `${startStr} - ${endStr}`;
    if (endStr) return `Until ${endStr}`;
    return "";
  }

  // Global Admin always sees the general country-listing version, even if
  // their own assigned country happens to also be exempted - the "your
  // market" personalized wording is reserved for non-Global-Admin viewers
  // (Market Admin, Basic User, AOW Admin) tied to a single country.
  get showExemptionBanner(): boolean {
    if (this.userRole === UserRoleEnum.GlobalAdmin) {
      return this.hasActiveException;
    }
    return !!this.ownCountryActiveException;
  }

  get exemptionBannerTitle(): string {
    return this.userRole === UserRoleEnum.GlobalAdmin
      ? "This Standard is Exempted"
      : "This Standard is Exempted for Your Market";
  }

  get exemptionBannerMessage(): string {
    if (this.userRole === UserRoleEnum.GlobalAdmin) {
      const period = this.formatExceptionPeriodRange(this.activeExceptions);
      return `This standard is exempted for ${this.exemptedCountryNames}.${period ? " Exception Period: " + period + "." : ""}`;
    }
    const period = this.formatExceptionPeriod(this.ownCountryActiveException);
    return `You are not required to comply with this Standard for your market.${period ? " Exception Period: " + period + "." : ""}`;
  }

  get hardwareDescription(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.emailDescription ||
      d?.keyContact?.EmailDescription ||
      d?.standard?.keyContact?.emailDescription ||
      d?.standard?.keyContact?.EmailDescription ||
      d?.standard?.emailDescription ||
      d?.standard?.EmailDescription ||
      d?.emailDescription ||
      d?.EmailDescription ||
      d?.keyContactDesc ||
      d?.standard?.keyContactDesc ||
      ""
    );
  }

  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  locationId: number = 0;
  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    public standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private ngbModal: NgbModal,
    private cryptographyService: CryptographyService,
    public locationService: LocationService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private location: Location
  ) {
    this.grsId = parseInt(this.activeRoute.snapshot.paramMap.get("grsId"));
    this.locationId = parseInt(
      this.activeRoute.snapshot.paramMap.get("locationId")
    );
  }

  ngOnInit() {
    this.userRole = sessionStorage.getItem("userRoleId")
      ? this.cryptographyService.decryptData(sessionStorage.getItem("userRoleId"))
      : this.cryptographyService.decryptData(this.storage.get("userRole"));
     
   
   

    this.getDetailByGrbesId(this.grsId);
    $(document).ready(() => {
      let objId;
      $(".image-map area")
        .mouseenter(function (e) {
          objId = $(this).attr("target");
          $(".main-image").css("opacity", "0");
          $(".main-image").css("z-index", "9999");
          $(objId).find("img").css("z-index", "2");
          $(objId).removeClass("d-none");
          $(objId).addClass("active");
          $(".chunk").removeClass("d-none");
          $(".tooltip-text span").text($(this).attr("alt"));
          $(".tooltip-text").css("left", e.pageX + 2);
          $(".tooltip-text").css("top", e.pageY + 2);
          $(".tooltip-text").fadeIn("slow");

          //   $('.main-image').fadeOut('slow');
        })
        .mouseleave(function (e) {
          $(".main-image").css("z-index", "1");
          $(".chunk").addClass("d-none");
          $(".chunk").removeClass("active");
          $(".main-image").css("opacity", "1");
          // $('.main-image').fadeTo('1');
          // $('.tooltip-text').hide();
        });
    });
  }

  getDetailByGrbesId(grsId: number) {
    console.log(this.storage.get("countryId"));
    //debugger;
    this.loading = true;
    this.standardService
      .getGrbesDetailInfomationByStandardId(
        grsId,
        this.countryIds,
        this.standardService.minimumStandardFiltration.filterSet,
        StandardListType.AllStandards,
        this.standardService.minimumStandardFiltration.searchKey,
        this.getAppliedFilters()
      )
      .subscribe((data: SelectedStandardDetail) => {
        var options = {
          /* … */
        };

        this.grsDetail = new SelectedStandardDetail(data);
        this.keyContactEmail = (this.grsDetail as any)?.keyContact?.email;
         this.allLocations = this.grsDetail.standard.standardLocation.length > 0 ? this.grsDetail.standard.standardLocation.map((loc:any) => loc.locationType.name)
          .join(", ") : this.grsDetail.standard.locationType.name;
        this.subLocations = this.grsDetail.standard.standardLocation
          .map((loc: any) =>
            loc.locationType.subLocationTypes?.length
              ? loc.locationType.subLocationTypes.map((sloc) => sloc.name).join(", ")
              : "",
          )
          .filter(Boolean)
          .join(", ");
        void 0;
        const cleanNotes = DOMPurify.sanitize(this.grsDetail.standard.note);
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);

        const cleanAddInfo = DOMPurify.sanitize(
          this.grsDetail.standard.additionalInformation
        );
        this.additionalInformation =
          this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);

        // this.notes = this.sanitizer.bypassSecurityTrustHtml(
        //   this.grsDetail.standard.note
        // );
        // this.additionalInformation = this.sanitizer.bypassSecurityTrustHtml(
        //   this.grsDetail.standard.additionalInformation
        // );

        this.loading = false;
        this.gapLoading = false;
        (error: string) => {
          this.error = error;
          this.loading = false;
        };
      });
  }

  navigateAccToType(type, id) {
    if (type == 4) {
      this.router.navigate(["/minimum-standard-detail-view/" + id]);
      return;
    }
    if (type == 8) {
      this.router.navigate(["/operations-standards-detail-view/" + id]);
      return;
    }
    if (type == 0) {
      this.router.navigate(["/view-equipments-standard-detail/" + id]);
      return;
    }
    if (type == 1 || type == 2) {
      this.router.navigate(["/global-recommendations-detail-view/" + id]);
      return;
    }
  }

  getAppliedFilters() {
    let idx =
      this.standardService.minimumStandardFiltration.filterSet.findIndex(
        (i) => i.type == FilteringEnum.FilterByStandardType
      );
    if (idx == -1) return [];
    return this.standardService.minimumStandardFiltration.filterSet[idx].ids;
  }

  slide(grsID: number, isForward: boolean) {
    this.loading = true;
    if (this.userRole != 2) {
      this.standardService
        .getNextPreviousGrsInfomationByCurrentStandardId(
          grsID,
          isForward,
          this.countryIds,
          this.standardService.minimumStandardFiltration.filterSet,
          StandardListType.AllStandards,
          this.standardService.minimumStandardFiltration.searchKey,
          this.getAppliedFilters()
        )
        .subscribe((data: SelectedStandardDetail) => {
          this.navigateAccToType(
            data.standard.standardTypeId,
            data.standard.id
          );
          var options = {
            /* … */
          };
          void 0;
          this.grsDetail = new SelectedStandardDetail(data);
          const cleanNotes = DOMPurify.sanitize(this.grsDetail.standard.note);
          this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);

          const cleanAddInfo = DOMPurify.sanitize(
            this.grsDetail.standard.additionalInformation
          );
          this.additionalInformation =
            this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);

          void 0;
          this.notes = this.sanitizer.bypassSecurityTrustHtml(
            this.grsDetail.standard.note
          );
          this.additionalInformation = this.sanitizer.bypassSecurityTrustHtml(
            this.grsDetail.standard.additionalInformation
          );
          this.loading = false;
          (error: string) => {
            this.error = error;
            this.loading = false;
          };
        });
    } else {
      this.standardService
        .getNextPreviousGrsInfomationByCurrentStandardId(
          grsID,
          isForward,
          this.countryIds,
          this.standardService.minimumStandardFiltration.filterSet,
          StandardListType.AllStandards,
          this.standardService.minimumStandardFiltration.searchKey,
          this.getAppliedFilters()
        )
        .subscribe((data: SelectedStandardDetail) => {
          this.navigateAccToType(
            data.standard.standardTypeId,
            data.standard.id
          );

          this.grsDetail = new SelectedStandardDetail(data);
          const cleanNotes = DOMPurify.sanitize(this.grsDetail.standard.note);
          this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);

          const cleanAddInfo = DOMPurify.sanitize(
            this.grsDetail.standard.additionalInformation
          );
          this.additionalInformation =
            this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);
          this.loading = false;
          (error: string) => {
            this.error = error;
            this.loading = false;
          };
        });
    }
  }

  addToNrbes(standardId, standardTypeId) {
    this.loading = true;
    this.standardService
      .addStandardToNrbes(
        standardId,
        this.countryId,
        standardTypeId === 0 ? 6 : 3,
        this.cryptographyService.decryptData(this.storage.get("userId"))
      )
      .subscribe(() => {
        this.loading = false;
        this.getDetailByGrbesId(this.grsDetail.standard.id);
      });
  }

  rowSelected(item: Standard): void {
    // this.standardService.fromLocationGRS = false;

    this.router.navigate(["/view-standard-detail/" + item.id]);
  }

  actionMenuOpen(event) {
    event.stopPropagation();
  }

  openDeleteModal(itemId, event) {
    event.stopPropagation();
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    modalRef.componentInstance.deleteItem = itemId;
    this.trigger.closeMenu();
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItemId) => {
      if (deleteItemId != null) {
        let grs = new SelectedStandard();
        grs.standard.id = deleteItemId;
        grs.standard.isDeleted = true;
        this.loading = true;
        this.standardService
          .removeGrbes(grs.standard)
          .subscribe((data: any) => {
            this.loading = false;
            this.getDetailByGrbesId(this.grsId);
          });
      }
      this.ngbModal.dismissAll();
    });
  }

  onEdit(id) {
    this.standardService.standardEditPreviousRoute =
      this.activeRoute.snapshot.routeConfig.path.split("/")[0] +
      "/" +
      this.grsDetail.standard.id;
    this.router.navigate(["/add-grs", id]);
  }
  downloadExcel() {
    this.standardService.downloadSingleStandardExcel(
      this.grsDetail,
      "building"
    );
    return;
  }

  isShareModalOpen = false;
  shareModalTitle = "";
  shareModalSubtitle = "";
  shareModalUrl = "";

  openShareModal(): void {
    const standard = (this.grsDetail as any)?.standard;
    this.shareModalTitle = standard?.title || "";
    this.shareModalSubtitle = [
      standard?.standardType?.name,
      standard?.category?.name,
    ]
      .filter(Boolean)
      .join(" · ");
    this.shareModalUrl = window.location.href;
    this.isShareModalOpen = true;
  }

  getLocationNames(item): any {
    if (item.standardLocation && item.standardLocation.length > 0) {
      return item.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    } else {
      return item.locationType.name;
    }
  }

    openSnackBar() {
      this._snackBar.openFromComponent(SnackbarComponent, {
        duration: 2 * 1000,
        data: {
          message: "Object Copied to clipboard!",
        },
      });
    }
  
    toggleDetails() {
      this.detailsExpanded = !this.detailsExpanded;
    }
    toggleDetails2() {
      this.additionalInfoExpanded = !this.additionalInfoExpanded;
    }
  
    copyText(content: any) {
      void 0;
      navigator.clipboard.writeText(content);
      this.openSnackBar();
    }
  
    getDetails() {
      return this.sanitizer.bypassSecurityTrustHtml(this.grsDetail.standard.note);
    }
    getAdditionalInfo() {
      return this.sanitizer.bypassSecurityTrustHtml(
        this.grsDetail.standard.additionalInformation,
      );
    }
    goBack() {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate(["/view-all-standards"]);
      }
    }
       get maxIndex(): number {
    return Math.max(0, this.grsDetail.dependentStandards.length - this.cardsVisible);
  }

  get canPrev(): boolean {
    return this.currentIndex > 0;
  }

  get canNext(): boolean {
    return this.currentIndex < this.maxIndex;
  }

  prev(): void {
    if (this.canPrev) {
      this.currentIndex--;
    }
  }

  next(): void {
    if (this.canNext) {
      this.currentIndex++;
    }
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  getTransformStyle(): string {
    const offset = (this.currentIndex * (100 / this.cardsVisible + 0.75));
    return `translateX(calc(-${offset}%))`;
  }
  get isSameDescription(): boolean {
  const newDesc = this.grsDetail?.standard?.newRestaurantDescription?.trim();
  const existingDesc = this.grsDetail?.standard?.description?.trim();

  return newDesc && existingDesc && newDesc === existingDesc;
}

get hasNewDescription(): boolean {
  return !!this.grsDetail?.standard?.newRestaurantDescription;
}

get hasExistingDescription(): boolean {
  return !!this.grsDetail?.standard?.description;
}
}
